<template>
    <rkm-row>
        <rkm-col>
            <rkm-form-incremental-textarea
                label=""
                :readonly="readonly"
                :items="data.form.observacoes"
                :validations="validations.observacoes"
                v-model="data.model.observacoes"
            >
                <template v-slot:row="{ item }">
                    <rkm-row>
                        <rkm-col cols="4">
                            <div>Setor: {{ item.centroCusto.setor.nome }}</div>
                            <div>{{ item.lotacao.profissional.nome }}</div>
                            <div>{{ item.dataHora }}</div>
                        </rkm-col>

                        <rkm-col>
                            {{ item.descricao }}
                        </rkm-col>
                    </rkm-row>
                </template>
            </rkm-form-incremental-textarea>
        </rkm-col>
    </rkm-row>
</template>

<script>
// Components.
import RkmFormIncrementalTextarea from '@/components/pronto-atendimento/components/base/FormIncrementalTextarea'

export default {
    components: { RkmFormIncrementalTextarea },
    computed: {
        validations() {
            return {
                observacoes: { max: 3000 },
            }
        },
    },
    props: {
        data: { type: Object, required: true },
        readonly: { type: Boolean, default: false },
    },
}
</script>